import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import ColorPicker from "components/common/ColorPicker";
import Popover from "components/common/Popover";
const COLUMNS = 5;
const ColorHint = styled.div(
  ({ $color, $clickable }) => css`
    flex-shrink: 0;
    cursor: ${$clickable ? "pointer" : "default"};
    background-color: ${$color} !important; /* Needed for report generation */
    -webkit-print-color-adjust: exact !important; /* Needed for report generation */
    width: 12px;
    height: 12px;
  `
);
const GridLegend = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(${COLUMNS}, 1fr);
    gap: ${theme.spacings.xxs} ${theme.spacings.xs};
    max-height: 100px;
    overflow: auto;
    padding: ${theme.spacings.xxs};
  `
);
const WrapLegend = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacings.xxs} ${theme.spacings.xs};
    padding: ${theme.spacings.xxs};
  `
);
const Entry = styled.div`
  display: flex;
  align-items: center;
`;
const Label = styled.div`
  margin-left: 5px;
  line-height: 1;
`;
const LegendEntry = ({ item: { key, label, color, title = key }, colorPicker = void 0 }) => {
  const { t } = useTranslation("aggregation");
  const [showPopover, setShowPopover] = useState(false);
  if (!colorPicker) {
    return /* @__PURE__ */ React.createElement(Entry, null, /* @__PURE__ */ React.createElement(ColorHint, { "aria-label": t("vis_common.color_hint"), $color: color, $clickable: false }), /* @__PURE__ */ React.createElement(Label, null, label));
  }
  const onColorSelect = (newColor) => {
    colorPicker.onChange(key, newColor);
    setShowPopover(false);
  };
  return /* @__PURE__ */ React.createElement(Entry, null, /* @__PURE__ */ React.createElement(Popover, { position: "top", withArrow: true, opened: showPopover }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(
    ColorHint,
    {
      "aria-label": t("vis_common.color_hint"),
      $color: color,
      $clickable: true,
      onClick: () => setShowPopover((show) => !show)
    }
  )), /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: t("vis_common.legend_configuration", { label: title }) }, /* @__PURE__ */ React.createElement(ColorPicker, { color, colors: colorPicker.colors, onChange: onColorSelect }))), /* @__PURE__ */ React.createElement(Label, null, label));
};
const ChartLegend = ({ items, layout = "wrap", colorPicker = void 0 }) => {
  const Container = layout === "grid" ? GridLegend : WrapLegend;
  return /* @__PURE__ */ React.createElement(Container, null, items.map((item) => /* @__PURE__ */ React.createElement(LegendEntry, { key: item.key, item, colorPicker })));
};
export default ChartLegend;
